export const capitalize = function(texto) {
    let prepos = ["da", "do", "das", "dos", "a", "e", "de" ];
    return texto.split(' ').map((palavra) => {
        if (/^([A-Z]\.)+$/.test(palavra) || /^M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/.test(palavra)) {
            return palavra;
        }
        palavra = palavra.toLowerCase();
        if (prepos.includes(palavra)) {
            return palavra;
        }
        return palavra.charAt(0).toUpperCase() + palavra.slice(1);
    }).join(' ');
};

export const validaCpfCnpj = function(val) {
    if (val.length == 14) {
        var cpf = val.trim();
     
        cpf = cpf.replace(/\./g, '');
        cpf = cpf.replace('-', '');
        cpf = cpf.split('');
        
        var v1 = 0;
        var v2 = 0;
        var aux = false;
        
        for (var i = 1; cpf.length > i; i++) {
            if (cpf[i - 1] != cpf[i]) {
                aux = true;   
            }
        } 
        
        if (aux == false) {
            return false; 
        } 
        
        for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
            v1 += cpf[i] * p; 
        } 
        
        v1 = ((v1 * 10) % 11);
        
        if (v1 == 10) {
            v1 = 0; 
        }
        
        if (v1 != cpf[9]) {
            return false; 
        } 
        
        for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
            v2 += cpf[i] * p; 
        } 
        
        v2 = ((v2 * 10) % 11);
        
        if (v2 == 10) {
            v2 = 0; 
        }
        
        if (v2 != cpf[10]) {
            return false; 
        } else {   
            return true; 
        }
    } else if (val.length == 18) {

        var cnpj = val.trim().toUpperCase();

        // Remove máscara: ponto, barra, hífen e espaços
        cnpj = cnpj.replace(/[.\-/\s]/g, '');

        // CNPJ alfanumérico:
        // 12 primeiros caracteres podem ser letras ou números
        // 2 últimos devem ser números
        if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj)) {
            return false;
        }

        // Evita sequências totalmente repetidas, como 00000000000000
        if (/^([A-Z0-9])\1{13}$/.test(cnpj)) {
            return false;
        }

        function valorParaCalculo(char) {
            return char.charCodeAt(0) - 48;
        }

        function calcularDigito(cnpjParcial, pesos) {
            var soma = 0;

            for (var i = 0; i < cnpjParcial.length; i++) {
                soma += valorParaCalculo(cnpjParcial[i]) * pesos[i];
            }

            var resto = soma % 11;

            return resto < 2 ? 0 : 11 - resto;
        }

        var pesosPrimeiroDigito = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        var pesosSegundoDigito = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        var primeiroDigito = calcularDigito(cnpj.substring(0, 12), pesosPrimeiroDigito);

        if (primeiroDigito != parseInt(cnpj[12], 10)) {
            return false;
        }

        var segundoDigito = calcularDigito(cnpj.substring(0, 13), pesosSegundoDigito);

        if (segundoDigito != parseInt(cnpj[13], 10)) {
            return false;
        }

        return true;
    } else {
        return false;
    }
 }

export const month = function(mes) {

    const meses = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez"
    ];

    return meses[mes];

}

export const weekday = function(dia) {

    const dias = [
        "DOM",
        "SEG",
        "TER",
        "QUA",
        "QUI",
        "SEX",
        "SAB",
    ];

    return dias[dia];

}

export const flags = {
    visa        : /^4\d{5}/,
    master      : /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]/,
    diners      : /^3(?:0[0-5]|[68][0-9])[0-9]/,
    amex        : /^3[47][0-9]{5,}$/,
    discover    : /^6(?:011|5[0-9]{2})[0-9]/,
    hipercard   : /^606282|^637095|^637599|^637568/,
    elo         : /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^504175|^627780|^63(6297|6368|6369)|(65003[5-9]|65004[0-9]|65005[01])|(65040[5-9]|6504[1-3][0-9])|(65048[5-9]|65049[0-9]|6505[0-2][0-9]|65053[0-8])|(65054[1-9]|6505[5-8][0-9]|65059[0-8])|(65070[0-9]|65071[0-8])|(65072[0-7])|(65090[1-9]|6509[1-6][0-9]|65097[0-8])|(65165[2-9]|6516[67][0-9])|(65500[0-9]|65501[0-9])|(65502[1-9]|6550[34][0-9]|65505[0-8])|^65003[1-3]|^(65003[5-9]|65004\d|65005[0-1])|^(65040[5-9]|6504[1-3]\d)|^(65048[5-9]|65049\d|6505[0-2]\d|65053[0-8])|^(65054[1-9]|6505[5-8]\d|65059[0-8])|^(65070\d|65071[0-8])|^65072[0-7]|^(65090[1-9]|65091\d|650920)|^(65165[2-9]|6516[6-7]\d)|^(65500\d|65501\d)|^(65502[1-9]|6550[3-4]\d|65505[0-8])/,
    jcb         : /^(?:2131|1800|35\d{3})\d/,
    aura        : /^(5078\d{2})(\d{2})(\d)$/,
    sodexo_alim : /^603389/,
    sodexo_gift : /^606068/,
    sodexo_prem : /^606069/,
    sodexo_refe : /^606071/,
    alelo       : /^(506699|5067[0-6][0-9]|50677[0-8])|^(509[0-8][0-9]{2}|5099[0-8][0-9]|50999[0-9])/,
};